// src/utils/routingApi.js
// CR-2026-SFM-UPLOAD-ROUTING — frontend API client for ABOM ingest + Release for Fabrication.
// Uses the existing ApiCall axios wrapper (same as documentsApi / tasksSlice).
import ApiCall from "./apicall";

// Phase 2 — ingest an assembly ABOM (parsed from material list / Tekla export / .nc1).
export async function ingestAbom(jobId, items) {
  const res = await ApiCall.post("/fabricated-items/ingest-abom", { job_Id: jobId, items });
  return res?.data?.data ?? res?.data;
}

// Phase 4 read — drafted-but-not-released pieces for a job, grouped by assembly.
export async function listDraftRouting(jobId) {
  const res = await ApiCall.get(`/fabrication/draft-routing?jobId=${encodeURIComponent(jobId)}`);
  return res?.data?.data ?? { assemblies: [], count: 0 };
}

// Phase 4 — PM Release for Fabrication. scope: 'piece' | 'sequence' | 'job'.
export async function releaseForFabrication({ scope, pieceId, sequenceId, jobId, note, approvalBasis, contractReference, riskAcknowledged }) {
  const res = await ApiCall.post("/fabrication/release-for-fabrication", {
    scope, pieceId, sequenceId, jobId, note, approvalBasis, contractReference, riskAcknowledged,
  });
  return res?.data?.data ?? res?.data;
}

// Progress — released pieces by assembly with % complete (measurable to completion).
export async function getAssemblyProgress(jobId) {
  const res = await ApiCall.get(`/fabrication/assembly-progress?jobId=${encodeURIComponent(jobId)}`);
  return res?.data?.data ?? { assemblies: [], overallPct: 0, count: 0 };
}
